import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import Input from "../../../../components/input";
import { PhysicalAndMentalSymptom } from "../../../../models";
import { updateChild, State } from "../actions/children";
import { useActionState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function UpdateChildForm({
  item,
  onCancel,
}: {
  item: PhysicalAndMentalSymptom;
  onCancel: () => void;
  
}) {
  const navigate = useNavigate();    
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
    },
  };
  const updateWithId = updateChild.bind(null, item.id!);
  const [state, formAction, isPending] = useActionState(
    updateWithId,
    initialState
  );
  useEffect(() => {
    if (state.success) {
      navigate(`/admin/physical-and-mental-symptoms/edit/${item.parentId}?reload=${Date.now()}`);
      toast.success("Symptom updated successfully");
      onCancel();
    }
    else if (state.errors && Object.keys(state.errors).length > 0) {
      toast.error("Failed to update symptom");
    }
  }, [state]);

  return (<td colSpan={2} className="px-6 py-4 bg-gray-100" >
    <form action={formAction} className="flex gap-2 w-full ">
      <Input
        className="w-full"
        name="name"
        id="name"
        placeholder="Name"
        required={true}
        defaultValue={item.name}
      ></Input>
      <input
        type="hidden"
        id="parentId"
        name="parentId"
        value={item.parentId}
      ></input>
      <IconButton label="Update" icon={CheckIcon} loading={isPending}></IconButton>
      <IconButton type="button" label="Cancel" icon={XMarkIcon} onClick={onCancel}   ></IconButton>
    </form>
    </td>
  );
}
